import { useEffect, useState } from 'react';

interface UseGlobalDragTrackingReturn {
  isGlobalDragging: boolean;
  isDraggingVideo: boolean;
  dragOverLastFrameKey: string | null;
  setDragOverLastFrameKey: React.Dispatch<React.SetStateAction<string | null>>;
  dragOverSceneKey: string | null;
  setDragOverSceneKey: React.Dispatch<React.SetStateAction<string | null>>;
}

export function useGlobalDragTracking(): UseGlobalDragTrackingReturn {
  const [isGlobalDragging, setIsGlobalDragging] = useState(false);
  const [isDraggingVideo, setIsDraggingVideo] = useState(false);
  const [dragOverLastFrameKey, setDragOverLastFrameKey] = useState<string | null>(null);
  const [dragOverSceneKey, setDragOverSceneKey] = useState<string | null>(null);

  useEffect(() => {
    let dragCounter = 0;

    const handleDragEnter = (e: DragEvent) => {
      dragCounter++;
      // 素材データを含むドラッグのみを検知
      if (e.dataTransfer?.types.includes('application/json')) {
        setIsGlobalDragging(true);
      }
    };

    const handleDragLeave = () => {
      dragCounter--;
      if (dragCounter === 0) {
        setIsGlobalDragging(false);
        setIsDraggingVideo(false);
      }
    };

    const handleDrop = (_e: DragEvent) => {
      // ポータル内のドロップハンドラが先に処理されるように少し遅延させる
      setTimeout(() => {
        dragCounter = 0;
        setIsGlobalDragging(false);
        setIsDraggingVideo(false);
        setDragOverLastFrameKey(null);
      }, 0);
    };

    const handleDragEnd = () => {
      dragCounter = 0;
      setIsGlobalDragging(false);
      setIsDraggingVideo(false);
      setDragOverLastFrameKey(null);
    };

    // 素材ドラッグ開始時のカスタムイベント（動画かどうかを検知）
    const handleMaterialDragStart = (e: Event) => {
      const customEvent = e as CustomEvent<{ isVideo: boolean }>;
      setIsDraggingVideo(customEvent.detail.isVideo);
    };

    document.addEventListener('dragenter', handleDragEnter);
    document.addEventListener('dragleave', handleDragLeave);
    document.addEventListener('drop', handleDrop);
    document.addEventListener('dragend', handleDragEnd);
    window.addEventListener('material-drag-start', handleMaterialDragStart);

    return () => {
      document.removeEventListener('dragenter', handleDragEnter);
      document.removeEventListener('dragleave', handleDragLeave);
      document.removeEventListener('drop', handleDrop);
      document.removeEventListener('dragend', handleDragEnd);
      window.removeEventListener('material-drag-start', handleMaterialDragStart);
    };
  }, []);

  return {
    isGlobalDragging,
    isDraggingVideo,
    dragOverLastFrameKey,
    setDragOverLastFrameKey,
    dragOverSceneKey,
    setDragOverSceneKey,
  };
}
